// Date 2021-03-19 18:16:53

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import sithMesInventoryItemList from "@/views/sithMes/inventory/SithMesInventoryItemList.vue";
import sithMesInventoryItemEdit from "@/views/sithMes/inventory/SithMesInventoryItemEdit.vue";
import sithMesInventoryPoList from "@/views/sithMes/inventory/SithMesInventoryPoList.vue";
import sithMesInventoryPoEdit from "@/views/sithMes/inventory/SithMesInventoryPoEdit.vue";
import sithMesInventoryAbnormalArrivalProcessTask
    from "@/views/sithMes/inventory/SithMesInventoryAbnormalArrivalProcessTask.vue";
import sithMesInventoryAbnormalArrivalProcessEdit
    from "@/views/sithMes/inventory/SithMesInventoryAbnormalArrivalProcessEdit.vue";
import sithMesInventoryAbnormalArrivalProcessList
    from "@/views/sithMes/inventory/SithMesInventoryAbnormalArrivalProcessList.vue";
import sithMesInventoryItemPrint from "@/views/sithMes/inventory/SithMesInventoryItemPrint";
import sithMesInventoryDeliveryMaterialPrint from "@/views/sithMes/inventory/SithMesInventoryDeliveryMaterialPrint";
import sithMesInventoryBinPrint from "@/views/sithMes/inventory/SithMesInventoryBinPrint";
import sithMesInventoryBinStatusPrint from "@/views/sithMes/inventory/SithMesInventoryBinSatusPrint";
import sithMesInventoryAddPrint from "@/views/sithMes/inventory/SithMesInventoryAddPrint";
import sithMesInventoryDeliveryTaskEdit from "@/views/sithMes/inventory/SithMesInventoryDeliveryTaskEdit.vue";
import sithMesInventoryDeliveryTaskList from "@/views/sithMes/inventory/SithMesInventoryDeliveryTaskList.vue";
import sithMesInventoryDeliveryMaterialList from "@/views/sithMes/inventory/SithMesInventoryDeliveryMaterialList.vue";
import sithMesInventoryDeliveryMaterialEdit from "@/views/sithMes/inventory/SithMesInventoryDeliveryMaterialEdit.vue";
import sithMesInventoryPackageEdit from "@/views/sithMes/inventory/SithMesInventoryPackageEdit.vue";
import sithMesInventoryPackageList from "@/views/sithMes/inventory/SithMesInventoryPackageList.vue";
import sithMesInventoryShipmentList from "@/views/sithMes/inventory/SithMesInventoryShipmentList.vue";
import sithMesInventoryShipmentEdit from "@/views/sithMes/inventory/SithMesInventoryShipmentEdit.vue";
import sithMesInventoryBinAddPrint from "@/views/sithMes/inventory/SithMesInventoryBinAddPrint";
import sithMesInventoryPackageMaterialList from "@/views/sithMes/inventory/SithMesInventoryPackageMaterialList.vue";
import sithMesInventoryPackageMaterialEdit from "@/views/sithMes/inventory/SithMesInventoryPackageMaterialEdit.vue";
import sithMesInventoryWmDefinitionList from "@/views/sithMes/inventory/SithMesInventoryWmDefinitionList.vue";
import sithMesInventoryWmDefinitionEdit from "@/views/sithMes/inventory/SithMesInventoryWmDefinitionEdit.vue";
import sithMesInventoryBinStatusList from "@/views/sithMes/inventory/SithMesInventoryBinStatusList.vue";
import sithMesInventoryBinStatusEdit from "@/views/sithMes/inventory/SithMesInventoryBinStatusEdit.vue";
import sithMesInventoryStorageInputList from "@/views/sithMes/inventory/SithMesInventoryStorageInputList.vue";
import sithMesInventoryStorageInputEdit from "@/views/sithMes/inventory/SithMesInventoryStorageInputEdit.vue";
import sithMesInventoryMaterialDispatchingList
    from "@/views/sithMes/inventory/SithMesInventoryMaterialDispatchingList.vue";
import sithMesInventoryMaterialDispatchingEdit
    from "@/views/sithMes/inventory/SithMesInventoryMaterialDispatchingEdit.vue";
import sithMesInventoryReplacementRepairEdit from "@/views/sithMes/inventory/SithMesInventoryReplacementRepairEdit.vue";
import sithMesInventoryReplacementRepairList from "@/views/sithMes/inventory/SithMesInventoryReplacementRepairList.vue";
import sithMesInventoryCountList from "@/views/sithMes/inventory/SithMesInventoryCountList.vue";
import sithMesInventoryCountEdit from "@/views/sithMes/inventory/SithMesInventoryCountEdit.vue";
import sithMesInventoryChangeMaterialProjectTask
    from "@/views/sithMes/inventory/SithMesInventoryChangeMaterialProjectTask.vue";
import sithMesInventoryChangeMaterialProjectEdit
    from "@/views/sithMes/inventory/SithMesInventoryChangeMaterialProjectEdit.vue";
import sithMesInventoryChangeMaterialProjectList
    from "@/views/sithMes/inventory/SithMesInventoryChangeMaterialProjectList.vue";
import sithMesInventoryTransportApplicationEdit
    from "@/views/sithMes/inventory/SithMesInventoryTransportApplicationEdit.vue";
import sithMesInventoryTransportApplicationTask
    from "@/views/sithMes/inventory/SithMesInventoryTransportApplicationTask.vue";
import sithMesInventoryTransportApplicationList
    from "@/views/sithMes/inventory/SithMesInventoryTransportApplicationList.vue";
import sithMesInventoryReceiptReturnRecordEdit
    from "@/views/sithMes/inventory/SithMesInventoryReceiptReturnRecordEdit.vue";
import sithMesInventoryReceiptReturnRecordList
    from "@/views/sithMes/inventory/SithMesInventoryReceiptReturnRecordList.vue";
import sithMesInventoryOutdoorProcessList from "@/views/sithMes/inventory/SithMesInventoryOutdoorProcessList";
import sithMesInventoryOutdoorProcessEdit from "@/views/sithMes/inventory/SithMesInventoryOutdoorProcessEdit";
import sithMesInventoryOutdoorProcessTask from "@/views/sithMes/inventory/SithMesInventoryOutdoorProcessTask";
import sithMesInventoryOutdoorProductDetailEdit
    from "@/views/sithMes/inventory/SithMesInventoryOutdoorProductDetailEdit";
import sithMesInventoryOutdoorProductDetailList
    from "@/views/sithMes/inventory/SithMesInventoryOutdoorProductDetailList";
import sithMesInventoryStockReturnEdit from "@/views/sithMes/inventory/SithMesInventoryStockReturnEdit.vue";
import sithMesInventoryStockReturnList from "@/views/sithMes/inventory/SithMesInventoryStockReturnList.vue";
import sithMesInventoryStockMovementList from "@/views/sithMes/inventory/SithMesInventoryStockMovementList.vue";
import sithMesInventoryStockMovementEdit from "@/views/sithMes/inventory/SithMesInventoryStockMovementEdit.vue";
import sithMesInventoryChangeProjectDetailList
    from "@/views/sithMes/inventory/SithMesInventoryChangeProjectDetailList.vue";
import sithMesInventoryChangeProjectDetailEdit
    from "@/views/sithMes/inventory/SithMesInventoryChangeProjectDetailEdit.vue";
import sithMesInventoryPackingBomList from "@/views/sithMes/inventory/SithMesInventoryPackingBomList.vue";
import sithMesInventoryPackingBomEdit from "@/views/sithMes/inventory/SithMesInventoryPackingBomEdit.vue";
import sithMesInventoryManualCheckEdit from "@/views/sithMes/inventory/SithMesInventoryManualCheckEdit.vue";
import sithMesInventoryManualCheckList from "@/views/sithMes/inventory/SithMesInventoryManualCheckList.vue";
import sithMesInventoryManualOutputList from "@/views/sithMes/inventory/SithMesInventoryManualOutputList.vue";
import sithMesInventoryManualOutputEdit from "@/views/sithMes/inventory/SithMesInventoryManualOutputEdit.vue";
import sithMesInventoryManualInputList from "@/views/sithMes/inventory/SithMesInventoryManualInputList.vue";
import sithMesInventoryManualInputEdit from "@/views/sithMes/inventory/SithMesInventoryManualInputEdit.vue";
import sithMesInventoryLiftCheckEdit from "@/views/sithMes/inventory/SithMesInventoryLiftCheckEdit.vue";
import sithMesInventoryLiftCheckList from "@/views/sithMes/inventory/SithMesInventoryLiftCheckList.vue";
import sithMesInventoryLiftRiggingsList from "@/views/sithMes/inventory/SithMesInventoryLiftRiggingsList.vue";
import sithMesInventoryLiftRiggingsEdit from "@/views/sithMes/inventory/SithMesInventoryLiftRiggingsEdit.vue";
import sithMesInventoryUnpackingEdit from "@/views/sithMes/inventory/SithMesInventoryUnpackingEdit.vue";
import sithMesInventoryUnpackingList from "@/views/sithMes/inventory/SithMesInventoryUnpackingList.vue";
import sithMesInventoryUnpackingScanCheck from "@/views/sithMes/inventory/SithMesInventoryUnpackingScanCheck.vue";
import sithMesInventoryUnpackingSign from "@/views/sithMes/inventory/SithMesInventoryUnpackingSign.vue";
import sithMesInventoryComprehensiveBusinessRecordList
    from "@/views/sithMes/inventory/SithMesInventoryComprehensiveBusinessRecordList.vue";
import sithMesInventoryComprehensiveBusinessRecordEdit
    from "@/views/sithMes/inventory/SithMesInventoryComprehensiveBusinessRecordEdit.vue";
import sithMesInventoryComprehensiveBusinessDetailEdit
    from "@/views/sithMes/inventory/SithMesInventoryComprehensiveBusinessDetailEdit.vue";
import sithMesInventoryComprehensiveBusinessDetailList
    from "@/views/sithMes/inventory/SithMesInventoryComprehensiveBusinessDetailList.vue";
import sithMesInventoryComprehensiveBusinessVendorAndSithInfoList
    from "@/views/sithMes/inventory/SithMesInventoryComprehensiveBusinessVendorAndSithInfoList.vue";
import sithMesInventoryComprehensiveBusinessVendorAndSithInfoEdit
    from "@/views/sithMes/inventory/SithMesInventoryComprehensiveBusinessVendorAndSithInfoEdit.vue";


const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/sithMes/inventory/sithMesInventoryOutdoorProductCategory/list",
        name: "sithMesInventoryOutdoorProductCategoryList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryOutdoorProductCategory/edit",
        name: "sithMesInventoryOutdoorProductCategoryEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/sithMes/inventory/sithMesInventoryAreaLoc/list",
        name: "sithMesInventoryAreaLocList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryAreaLoc/edit",
        name: "sithMesInventoryAreaLocEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryReceiveErrorType/list",
        name: "sithMesInventoryReceiveErrorTypeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryReceiveErrorType/edit",
        name: "sithMesInventoryReceiveErrorTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryStatus/list",
        name: "sithMesInventoryStatusList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryStatus/edit",
        name: "sithMesInventoryStatusEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryItemList",
        name: "sithMesInventoryItemList",
        component: sithMesInventoryItemList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryItemEdit",
        name: "sithMesInventoryItemEdit",
        component: sithMesInventoryItemEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPoList",
        name: "sithMesInventoryPoList",
        component: sithMesInventoryPoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPoEdit",
        name: "sithMesInventoryPoEdit",
        component: sithMesInventoryPoEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryAbnormalArrivalProcessTask",
        name: "sithMesInventoryAbnormalArrivalProcessTask",
        component: sithMesInventoryAbnormalArrivalProcessTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryAbnormalArrivalProcessEdit",
        name: "sithMesInventoryAbnormalArrivalProcessEdit",
        component: sithMesInventoryAbnormalArrivalProcessEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryAbnormalArrivalProcessList",
        name: "sithMesInventoryAbnormalArrivalProcessList",
        component: sithMesInventoryAbnormalArrivalProcessList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPrint",
        name: "sithMesInventoryItemPrint",
        component: sithMesInventoryItemPrint,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPrint",
        name: "sithMesInventoryDeliveryMaterialPrint",
        component: sithMesInventoryDeliveryMaterialPrint,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryBinStatusPrint",
        name: "sithMesInventoryBinStatusPrint",
        component: sithMesInventoryBinStatusPrint,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryAddPrint",
        name: "sithMesInventoryAddPrint",
        component: sithMesInventoryAddPrint,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryDeliveryTaskEdit",
        name: "sithMesInventoryDeliveryTaskEdit",
        component: sithMesInventoryDeliveryTaskEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryDeliveryTaskList",
        name: "sithMesInventoryDeliveryTaskList",
        component: sithMesInventoryDeliveryTaskList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryDeliveryMaterialList",
        name: "sithMesInventoryDeliveryMaterialList",
        component: sithMesInventoryDeliveryMaterialList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryDeliveryMaterialEdit",
        name: "sithMesInventoryDeliveryMaterialEdit",
        component: sithMesInventoryDeliveryMaterialEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPackageEdit",
        name: "sithMesInventoryPackageEdit",
        component: sithMesInventoryPackageEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPackageList",
        name: "sithMesInventoryPackageList",
        component: sithMesInventoryPackageList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryShipmentList",
        name: "sithMesInventoryShipmentList",
        component: sithMesInventoryShipmentList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryShipmentEdit",
        name: "sithMesInventoryShipmentEdit",
        component: sithMesInventoryShipmentEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryBinPrint",
        name: "sithMesInventoryBinPrint",
        component: sithMesInventoryBinPrint,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryBinAddPrint",
        name: "sithMesInventoryBinAddPrint",
        component: sithMesInventoryBinAddPrint,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryBinAddPrint",
        name: "sithMesInventoryBinAddPrint",
        component: sithMesInventoryBinAddPrint,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPackageMaterialList",
        name: "sithMesInventoryPackageMaterialList",
        component: sithMesInventoryPackageMaterialList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPackageMaterialEdit",
        name: "sithMesInventoryPackageMaterialEdit",
        component: sithMesInventoryPackageMaterialEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryWmStock/list",
        name: "sithMesInventoryWmStockList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryWmStock/edit",
        name: "sithMesInventoryWmStockEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryWmDefinitionList",
        name: "sithMesInventoryWmDefinitionList",
        component: sithMesInventoryWmDefinitionList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryWmDefinitionEdit",
        name: "sithMesInventoryWmDefinitionEdit",
        component: sithMesInventoryWmDefinitionEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryBinStatusList",
        name: "sithMesInventoryBinStatusList",
        component: sithMesInventoryBinStatusList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryBinStatusEdit",
        name: "sithMesInventoryBinStatusEdit",
        component: sithMesInventoryBinStatusEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryStorageInputList",
        name: "sithMesInventoryStorageInputList",
        component: sithMesInventoryStorageInputList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryStorageInputEdit",
        name: "sithMesInventoryStorageInputEdit",
        component: sithMesInventoryStorageInputEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryMaterialDispatchingList",
        name: "sithMesInventoryMaterialDispatchingList",
        component: sithMesInventoryMaterialDispatchingList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryMaterialDispatchingEdit",
        name: "sithMesInventoryMaterialDispatchingEdit",
        component: sithMesInventoryMaterialDispatchingEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryReplacementRepairEdit",
        name: "sithMesInventoryReplacementRepairEdit",
        component: sithMesInventoryReplacementRepairEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryReplacementRepairList",
        name: "sithMesInventoryReplacementRepairList",
        component: sithMesInventoryReplacementRepairList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryCountList",
        name: "sithMesInventoryCountList",
        component: sithMesInventoryCountList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryCountEdit",
        name: "sithMesInventoryCountEdit",
        component: sithMesInventoryCountEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryChangeMaterialProjectTask",
        name: "sithMesInventoryChangeMaterialProjectTask",
        component: sithMesInventoryChangeMaterialProjectTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryChangeMaterialProjectEdit",
        name: "sithMesInventoryChangeMaterialProjectEdit",
        component: sithMesInventoryChangeMaterialProjectEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryChangeMaterialProjectList",
        name: "sithMesInventoryChangeMaterialProjectList",
        component: sithMesInventoryChangeMaterialProjectList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryTransportApplicationEdit",
        name: "sithMesInventoryTransportApplicationEdit",
        component: sithMesInventoryTransportApplicationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryTransportApplicationTask",
        name: "sithMesInventoryTransportApplicationTask",
        component: sithMesInventoryTransportApplicationTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryTransportApplicationList",
        name: "sithMesInventoryTransportApplicationList",
        component: sithMesInventoryTransportApplicationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryReceiptReturnRecordEdit",
        name: "sithMesInventoryReceiptReturnRecordEdit",
        component: sithMesInventoryReceiptReturnRecordEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventorySapRecord103List",
        name: "sithMesInventorySapRecord103List",
        component: sithMesInventoryReceiptReturnRecordList,
        props: (route) => ({prop_inline: route.query.inline, pageName: '103'}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventorySapRecord105List",
        name: "sithMesInventorySapRecord105List",
        component: sithMesInventoryReceiptReturnRecordList,
        props: (route) => ({prop_inline: route.query.inline, pageName: '105'}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventorySapRecord101FailedList",
        name: "sithMesInventorySapRecord101FailedList",
        component: sithMesInventoryReceiptReturnRecordList,
        props: (route) => ({prop_inline: route.query.inline, pageName: '101Failed'}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventorySapRecord104List",
        name: "sithMesInventorySapRecord104List",
        component: sithMesInventoryReceiptReturnRecordList,
        props: (route) => ({prop_inline: route.query.inline, pageName: '104'}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryOutdoorProcessList",
        name: "sithMesInventoryOutdoorProcessList",
        component: sithMesInventoryOutdoorProcessList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryOutdoorProcessEdit",
        name: "sithMesInventoryOutdoorProcessEdit",
        component: sithMesInventoryOutdoorProcessEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryOutdoorProcessTask",
        name: "sithMesInventoryOutdoorProcessTask",
        component: sithMesInventoryOutdoorProcessTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryOutdoorProductDetailEdit",
        name: "sithMesInventoryOutdoorProductDetailEdit",
        component: sithMesInventoryOutdoorProductDetailEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryOutdoorProductDetailList",
        name: "sithMesInventoryOutdoorProductDetailList",
        component: sithMesInventoryOutdoorProductDetailList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryStockReturnEdit",
        name: "sithMesInventoryStockReturnEdit",
        component: sithMesInventoryStockReturnEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryStockReturnList",
        name: "sithMesInventoryStockReturnList",
        component: sithMesInventoryStockReturnList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryStockMovementList",
        name: "sithMesInventoryStockMovementList",
        component: sithMesInventoryStockMovementList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryStockMovementEdit",
        name: "sithMesInventoryStockMovementEdit",
        component: sithMesInventoryStockMovementEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryChangeProjectDetailList",
        name: "sithMesInventoryChangeProjectDetailList",
        component: sithMesInventoryChangeProjectDetailList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryChangeProjectDetailEdit",
        name: "sithMesInventoryChangeProjectDetailEdit",
        component: sithMesInventoryChangeProjectDetailEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPackingBomList",
        name: "sithMesInventoryPackingBomList",
        component: sithMesInventoryPackingBomList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryPackingBomEdit",
        name: "sithMesInventoryPackingBomEdit",
        component: sithMesInventoryPackingBomEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualStorageType/list",
        name: "sithMesInventoryManualStorageTypeList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualStorageType/edit",
        name: "sithMesInventoryManualStorageTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualMaterialType/list",
        name: "sithMesInventoryManualMaterialTypeList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualMaterialType/edit",
        name: "sithMesInventoryManualMaterialTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualCheckEdit",
        name: "sithMesInventoryManualCheckEdit",
        component: sithMesInventoryManualCheckEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualCheckList",
        name: "sithMesInventoryManualCheckList",
        component: sithMesInventoryManualCheckList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualInputEdit",
        name: "sithMesInventoryManualInputEdit",
        component: sithMesInventoryManualInputEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualInputList",
        name: "sithMesInventoryManualInputList",
        component: sithMesInventoryManualInputList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualOutputList",
        name: "sithMesInventoryManualOutputList",
        component: sithMesInventoryManualOutputList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryManualOutputEdit",
        name: "sithMesInventoryManualOutputEdit",
        component: sithMesInventoryManualOutputEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryLiftCheckEdit",
        name: "sithMesInventoryLiftCheckEdit",
        component: sithMesInventoryLiftCheckEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryLiftCheckList",
        name: "sithMesInventoryLiftCheckList",
        component: sithMesInventoryLiftCheckList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryLiftRiggingsList",
        name: "sithMesInventoryLiftRiggingsList",
        component: sithMesInventoryLiftRiggingsList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryLiftRiggingsEdit",
        name: "sithMesInventoryLiftRiggingsEdit",
        component: sithMesInventoryLiftRiggingsEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryUnpackingEdit",
        name: "sithMesInventoryUnpackingEdit",
        component: sithMesInventoryUnpackingEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryUnpackingList",
        name: "sithMesInventoryUnpackingList",
        component: sithMesInventoryUnpackingList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryUnpackingScanCheck",
        name: "sithMesInventoryUnpackingScanCheck",
        component: sithMesInventoryUnpackingScanCheck,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryUnpackingSign",
        name: "sithMesInventoryUnpackingSign",
        component: sithMesInventoryUnpackingSign,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryComprehensiveBusinessRecordList",
        name: "sithMesInventoryComprehensiveBusinessRecordList",
        component: sithMesInventoryComprehensiveBusinessRecordList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryComprehensiveBusinessRecordEdit",
        name: "sithMesInventoryComprehensiveBusinessRecordEdit",
        component: sithMesInventoryComprehensiveBusinessRecordEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryComprehensiveBusinessDetailEdit",
        name: "sithMesInventoryComprehensiveBusinessDetailEdit",
        component: sithMesInventoryComprehensiveBusinessDetailEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryComprehensiveBusinessDetailList",
        name: "sithMesInventoryComprehensiveBusinessDetailList",
        component: sithMesInventoryComprehensiveBusinessDetailList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryComprehensiveBusinessVendorAndSithInfoList",
        name: "sithMesInventoryComprehensiveBusinessVendorAndSithInfoList",
        component: sithMesInventoryComprehensiveBusinessVendorAndSithInfoList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/inventory/sithMesInventoryComprehensiveBusinessVendorAndSithInfoEdit",
        name: "sithMesInventoryComprehensiveBusinessVendorAndSithInfoEdit",
        component: sithMesInventoryComprehensiveBusinessVendorAndSithInfoEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }

]
